export const API_BASE = (
    process.env.REACT_APP_BACKEND_URL || 'https://backend-for-coffee.onrender.com'
).replace(/\/$/, '');

export const request = async (url, method = 'GET', body = null) => {
    const options = { method };

    if (body) {
        options.body = body;
        options.headers = { 'Content-Type': 'application/json' };
    }

    const response = await fetch(url, options);

    if (!response.ok) {
        throw new Error(`Could not fetch ${url}, status: ${response.status}`);
    }

    return response.json();
};

export const withEntityIds = (items) => {
    const list = Array.isArray(items) ? items : [];

    return list.map((item) => {
        const rawId = item.id ?? item._id;
        const id = rawId && typeof rawId === 'object'
            ? String(rawId.$oid || rawId.toString())
            : String(rawId);

        return { ...item, id };
    });
};
